export default __webpack_public_path__ + "img/information-error.1c0734e5.svg";